import { Opportunity } from './opportunity';

export class ResponseOportunity {
    results: Opportunity[];
    rowCount: number;
    currentPage: number;
    firstRowOnPage: number;
    lastRowOnPage: number;
    pageCount: number;
    pageSize: number;
}
